module.exports = __webpack_public_path__ + "img/Noctiluca-Process-5.39bd0c8e.png";